
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gaming-videos/one",
      function () {
        return require("private-next-pages/gaming-videos/one.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gaming-videos/one"])
      });
    }
  